import React, { useEffect } from "react";
import { useState } from "react";
import { post } from "../../components/api";
import { Col, Dropdown, Modal, Row } from "react-bootstrap";
import "../../components/ProgressBar.css";
import "./style.css";
// Table,
import DataTablePagination1 from "../../components/paginateTable1";
import { IoSearch } from "react-icons/io5";
import { MdOutlineDelete } from "react-icons/md";
// import { VscSaveAs } from "react-icons/vsc";
import { IoMdEye } from "react-icons/io";
import { showConfirmDialog } from "../../helpers/helper";
import AssignVehicleModal from "./assignTyre";
import { SweetAlert } from "../../helpers/helper";
import { useNavigate } from "react-router-dom";
import moment from "moment";
// import ReactToast from "../../components/ReactToast";
import { BsThreeDotsVertical } from "react-icons/bs";
import { BiMessageEdit } from "react-icons/bi";
import DatePicker from "react-datepicker";
import { RiTruckLine } from "react-icons/ri";

const TyreManagement = () => {
  const [tyres, setTyres] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [selectedTyre, setSelectedTyre] = useState([]);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalDoc, setTotalDoc] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState({});
  const [showDropdown, setShowDropdown] = useState({});
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusData, setStatusData] = useState({});
  const [selectedType, setSelectedType] = useState("");
  const [date, setDate] = useState(new Date());
  const [dashboardData, setDashboardData] = useState([]);
  const [typeSearch, setTypeSearch] = useState("");

  const navigate = useNavigate();

  const handleMouseEnter = (index) => {
    setShowDropdown((prev) => ({ ...prev, [index]: true }));
  };

  const handleMouseLeave = (index) => {
    setShowDropdown((prev) => ({ ...prev, [index]: false }));
  };

  const columns = [
    {
      name: "Vehicle No",
      selector: (row) => row.vehicleNo,
      sortable: true,
    },
    {
      name: "Tyre No",
      selector: (row) => row.tyreNo,
      sortable: true,
    },
    {
      name: "Brand",
      selector: (row) => row.brand,
      sortable: true,
    },
    {
      name: "Usage",
      selector: (row) => `${row.usage}/${row.manufacturerKmGuarantee}`,
      sortable: true,
    },
    {
      name: "Percentage",
      selector: (row) => row.percentage,
      sortable: true,
      cell: (row) => {
        const percentage = row.percentage;
        let bgColor = "#f44336d6";
        if (percentage > 66) {
          bgColor = "#4caf50cf";
        } else if (percentage < 66 && percentage > 33) {
          bgColor = "#ffc107cc";
        }
        return (
          <div
            style={{
              backgroundColor:
                row.type == "burst" || row.type == "expired"
                  ? "#f44336d6"
                  : bgColor,
              padding: "5px 10px",
              borderRadius: "5px",
              textAlign: "center",
              color: "white",
              fontWeight: "bold",
            }}
          >
            {percentage.toFixed(2)}%
          </div>
        );
      },
    },
    {
      name: "Status",
      selector: (row) => row.type,
      cell: (row) => {
        const color =
          row.type == "running"
            ? "green"
            : row.type == "unused"
            ? "#fa8500"
            : "red";
        return (
          <div
            style={{
              padding: "4px 7px",
              border: `1px solid ${color}`,
              borderRadius: "4px",
              color: `${color}`,
            }}
          >
            {row.type}
          </div>
        );
      },
    },
    {
      name: "Action",
      selector: (row) => row._id,
      sortable: true,
      cell: (row, i) => {
        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <Dropdown
              onMouseEnter={() => handleMouseEnter(i)}
              onMouseLeave={() => handleMouseLeave(i)}
              show={showDropdown[i] || false}
            >
              <Dropdown.Toggle as="div" className="tyre_dropdownToggle">
                <BsThreeDotsVertical size={16} color="black" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="tyre_dropdownMenu" align="end">
                <Dropdown.Item
                  className="tyre_dropdownItem"
                  onClick={() => hadleViewTyre(row)}
                >
                  <IoMdEye />
                  <span>view</span>
                </Dropdown.Item>
                {row?.currentVehicleId && (
                  <Dropdown.Item
                    className="tyre_dropdownItem"
                    onClick={() => handleVehicle(row)}
                  >
                    <RiTruckLine />
                    <span>Vehicle</span>
                  </Dropdown.Item>
                )}
                {row.type == "running" ? (
                  <Dropdown.Item
                    className="tyre_dropdownItem"
                    onClick={() => handleStatus(row)}
                  >
                    <BiMessageEdit />
                    <span>Status Change</span>
                  </Dropdown.Item>
                ) : row.type == "burst" ? (
                  <Dropdown.Item className="tyre_dropdownItem">
                    <BiMessageEdit />
                    <span>no changes</span>
                  </Dropdown.Item>
                ) : row.type == "expired" ? (
                  <Dropdown.Item className="tyre_dropdownItem">
                    <BiMessageEdit />
                    <span>no changes</span>
                  </Dropdown.Item>
                ) : (
                  <Dropdown.Item
                    className="tyre_dropdownItem"
                    onClick={() => hadleAssign(row)}
                  >
                    <BiMessageEdit />
                    <span>Assign Vehicle</span>
                  </Dropdown.Item>
                )}
                <Dropdown.Item
                  className="tyre_dropdownItem"
                  onClick={() => handleDelete(row)}
                >
                  <MdOutlineDelete size={16} className="" />
                  <span>Delete</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        );
      },
    },
  ];

  const fetchTyre = async () => {
    try {
      const response = await post("admin/getTyres", {
        page: page,
        limit: perPage,
        search: search,
        type: typeSearch,
      });
      if (response.status == 200) {
        setTyres(response.data);
        setTotalDoc(response.totalDocuments);
        setDashboardData(response.dashboardData);
      } else {
        setTyres([]);
      }
    } catch (error) {
      console.log("error", error.message || "error");
      setTyres([]);
    }
  };
  useEffect(() => {
    fetchVehicle();
  }, []);
  useEffect(() => {
    fetchTyre();
  }, [typeSearch, perPage, page]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchTyre();
    }, 2000);
    return () => clearTimeout(timer);
  }, [search]);

  const handleDelete = async (data) => {
    try {
      const showDialog = await showConfirmDialog(
        "Delete Tyre",
        "Are you sure you want to Delete tyre?",
        "Yes, Delete it!",
        "No"
      );
      if (showDialog) {
        const response = await post(`admin/delete_tyre/${data._id}`, {});
        if (response.status == 200) {
          SweetAlert(response?.message || "delete Successfully", false);
          fetchTyre();
        } else {
          SweetAlert(response?.message || "error deleting tyre", true);
        }
      }
    } catch (error) {
      SweetAlert(error.message || "error", true);
    }
  };

  const fetchVehicle = async () => {
    try {
      const result = await post("admin/Vehicle-tyres");
      if (result.status == 200) {
        const filteredArray = result.data.map((data) => {
          return {
            value: data._id,
            label: data.vehicleNo,
            tyreModel: data?.tyreModel,
          };
        });
        setVehicles(filteredArray);
      } else {
        SweetAlert(result.message, true);
        setVehicles([]);
      }
    } catch (error) {
      console.log(error.message || "Internal error while fetching vehicles.");
    }
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await post("admin/assign_vehicle", {
        ...data,
      });
      if (response.status === 200) {
        SweetAlert(response?.message, false);
        fetchTyre();
        setLoading(false);
        handleClose();
      } else {
        SweetAlert(response?.message, true);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error assigning tyre:", error);
      alert("Failed to assign tyre");
    }
  };

  const handleClose = () => {
    setShowAssignModal(false);
    setSelectedTyre(null);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };
  const handleViewCloseModal = () => {
    setViewData({});
    setShowViewModal(false);
  };

  const hadleViewTyre = (data) => {
    setShowViewModal(true);
    setViewData(data);
    // setDescription(data?.description);
  };

  const handleVehicle = (data) => {
    navigate("/vehicle_tyre_list", { state: { data: data } });
  };

  const handleStatus = (data) => {
    setSelectedType(data.type);
    setShowStatusModal(true);
    setStatusData(data);
  };

  const hadleAssign = (data) => {
    navigate("/single_tyre_assign", {
      state: { vehiclesList: vehicles, data: data },
    });
  };

  const handleStatusModalCancel = () => {
    setShowStatusModal(false);
    setStatusData({});
    setSelectedType("");
  };

  const submitType = async () => {
    try {
      const result = await post("/admin/tyre/status_change", {
        type: selectedType,
        id: statusData._id,
        date: date,
      });
      if (result.status == 200) {
        fetchTyre();
        setTimeout(() => {
          SweetAlert("status changed to:" + selectedType, false);
        }, 100);
      } else {
        SweetAlert(result.message, true);
      }
      setSelectedType("");
      setDate(new Date());
      setShowStatusModal(false);
    } catch (error) {
      console.log(error.message || "error");
      SweetAlert("error", true);
      handleStatusModalCancel();
    }
  };

  const handleTypeSelection = (type) => {
    if (typeSearch == type) {
      setTypeSearch("");
    } else {
      setTypeSearch(type);
    }
  };
  return (
    <div className="reportsWrapper">
      <AssignVehicleModal
        show={showAssignModal}
        onClose={handleClose}
        onSubmit={handleSubmit}
        tyre={selectedTyre}
        vehicles={vehicles}
        loading={loading}
      />
      <Modal
        show={showViewModal}
        onHide={handleViewCloseModal}
        size="xl"
        className="tyre_history"
      >
        <Modal.Header closeButton>
          <Modal.Title>Tyre History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <Row style={{ fontSize: "14px" }}>
              <Col md={4} xs={12}>
                <h5 style={{ fontSize: "16px" }}>Tyre Details</h5>
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <td>
                        <strong>Brand Name</strong>
                      </td>
                      <td>{viewData?.brand}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Position</strong>
                      </td>
                      <td>{viewData?.position || 0}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Serial Number</strong>
                      </td>
                      <td>{viewData?.tyreNo}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Tyre Status</strong>
                      </td>
                      <td>{viewData?.type}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Vehicle Assigned</strong>
                      </td>
                      <td>{viewData?.vehicleNo || "No vehicle Assigned"}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Issued Date</strong>
                      </td>
                      <td>
                        {moment(viewData?.installationDate)
                          .add(5, "hours")
                          .add(30, "minutes")
                          .format("DD/MM/YY")}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Vendor Name</strong>
                      </td>
                      <td>{viewData?.vendor}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>P.O. Number</strong>
                      </td>
                      <td>{viewData?.po}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Usage </strong>
                      </td>
                      <td>{viewData?.usage}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>percentage </strong>
                      </td>
                      <td>{viewData?.percentage}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col md={8} xs={12}>
                <h5 style={{ fontSize: "16px" }}>Tyre History</h5>
                <div>
                  {/* Current Tyre Installation */}
                  <div className="mb-3 p-3 border">
                    {viewData.installationDate && <h6 className="mb-1">
                      {moment(viewData.installationDate).format(
                        "DD MMMM, YYYY"
                      )}
                    </h6>}
                    <p className="mb-1">
                      <strong>Install - Bill no.: {viewData.po}</strong>
                    </p>
                    <p className="mb-1">
                      {viewData.brand} tyre: <strong>{viewData.tyreNo}</strong>{" "}
                      | Position: {viewData.position}
                    </p>
                    <p className="mb-1">
                      Status: <strong>{viewData.type}</strong> | Opening km:{" "}
                      {viewData.installationOdometer} | Closing km:{" "}
                      {viewData.type == "unused" ? 0 : "Present"}
                    </p>
                  </div>

                  {viewData.history?.length > 0
                    ? [...viewData.history].map((history, index) => (
                        <div key={index} className="mb-3 p-3 border">
                          <h6 className="mb-1">
                            {moment(history.installedAt).format(
                              "DD MMMM, YYYY"
                            )}{" "}
                            |{" "}
                            {moment(history.uninstalledAt).format(
                              "DD MMMM, YYYY"
                            )}
                          </h6>
                          <p className="mb-1">
                            VehicleNo : {history.vehicleNo || "null"} |
                            Position: {history.position}
                          </p>
                          <p className="mb-1">
                            Status: <strong>{history.type}</strong> | Used:{" "}
                            {history.kmUsed} km | Opening km:{" "}
                            {history.startOdometer} | Closing km:{" "}
                            {history.endOdometer}
                          </p>
                        </div>
                      ))
                    : null}
                </div>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="modal"
        show={showStatusModal}
        onHide={handleStatusModalCancel}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="route-label mb-2">Type</label>
          <div className="row">
            {[
              { value: "unused", label: "Unused" },
              { value: "burst", label: "Burst" },
              {
                value: "remoulded",
                label: "Remoulded",
              },
              {
                value: "expired",
                label: "Expired",
              },
            ].map((option) => (
              <div
                key={option.value}
                className={`col-md-6 col-lg-6 col-xs-12 tyre_radioInput`}
              >
                <input
                  type="radio"
                  id={option.value}
                  name="clientType"
                  value={option.value}
                  onChange={(e) => setSelectedType(e.target.value)}
                  checked={selectedType === option.value}
                  className="tyre_radioInput1"
                />
                <label htmlFor={option.value} className="tyre_radioLabel">
                  {option.label}
                </label>
              </div>
            ))}
            <div className="col-md-6 col-lg-12 col-xs-12 mt-3">
              {selectedType !== "running" ? (
                <>
                  <label className="route-label mb-2">Select Date</label>
                  <DatePicker
                    selected={date}
                    onChange={(date) => setDate(date)}
                    maxDate={Date.now()}
                    dateFormat={"dd/MM/yyyy"}
                  />
                </>
              ) : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex align-items-center justify-content-end gap-2">
            <button
              style={{
                backgroundColor: "#2A7C76",
                color: "white",
                padding: "5px 10px",
                border: "none",
                borderRadius: "8px",
              }}
              className="submit-btn"
              onClick={submitType}
            >
              save
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <div className="d-flex justify-content-between">
        <div className="p-0">
          <h5 className={`page-title text-left`}>Tyre Managements</h5>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "end",
          }}
          className="mb-2"
        >
          <div className="input-group" style={{ width: "250px" }}>
            <span className="input-group-text" id="basic-addon1">
              <IoSearch />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search Vehicle"
              aria-label="Vehicle"
              aria-describedby="basic-addon1"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <div
              style={{
                paddingBlock: "0.5rem",
                // marginBottom: "10px",
                background: "transparent",
                border: "1px solid #2a7c76",
                color: "#2a7c76",
                borderRadius: "4px",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                width: "100px",
                cursor: "pointer",
                float: "right",
              }}
              onClick={() =>
                navigate("/add-tyre", {
                  state: { vehiclesList: vehicles },
                })
              }
            >
              <a
                style={{
                  textDecoration: "none",
                  fontSize: "0.9rem",
                  // color: "white",
                  fontWeight: "500",
                }}
              >
                Add Tyre
              </a>
            </div>
            <div
              style={{
                paddingBlock: "0.5rem",
                // marginBottom: "10px",
                background: " #2a7c76",
                borderRadius: "4px",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                width: "120px",
                cursor: "pointer",
                float: "right",
              }}
              onClick={() =>
                navigate("/tyre-assign", {
                  state: { vehiclesList: vehicles },
                })
              }
            >
              <a
                style={{
                  textDecoration: "none",
                  fontSize: "0.9rem",
                  color: "white",
                  fontWeight: "500",
                }}
              >
                Assign Vehicle
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="card" style={{ padding: "15px" }}>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "30px",
            }}
            className="tyre-parent"
          >
            <div>
              <div className="tire-status-card">
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {vehicles.length}
                </p>
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "14px",
                    fontWeight: "300",
                  }}
                >
                  vehicles
                </p>
              </div>
            </div>
            <div>|</div>
            <div>
              <div className="tire-status-card">
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {totalDoc}
                </p>
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "14px",
                    fontWeight: "300",
                  }}
                >
                  tyres
                </p>
              </div>
            </div>
            <div>|</div>
            <div
              className={`control-box ${
                typeSearch == "running" ? "selected" : ""
              }`}
              onClick={() => handleTypeSelection("running")}
            >
              <div className="tire-status-card">
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {dashboardData?.find((data) => data._id === "running")
                    ?.count ?? 0}
                </p>
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "14px",
                    fontWeight: "300",
                  }}
                >
                  running
                </p>
              </div>
            </div>
            <div>|</div>
            <div
              className={`control-box ${
                typeSearch == "unused" ? "selected" : ""
              }`}
            >
              <div
                className="tire-status-card"
                onClick={() => handleTypeSelection("unused")}
              >
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {dashboardData?.find((data) => data._id === "unused")
                    ?.count ?? 0}
                </p>
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "14px",
                    fontWeight: "300",
                  }}
                >
                  unused
                </p>
              </div>
            </div>
            <div>|</div>
            <div
              className={`control-box ${
                typeSearch == "burst" ? "selected" : ""
              }`}
              onClick={() => handleTypeSelection("burst")}
            >
              <div className="tire-status-card">
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {dashboardData?.find((data) => data._id === "burst")?.count ??
                    0}
                </p>
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "14px",
                    fontWeight: "300",
                  }}
                >
                  burst
                </p>
              </div>
            </div>
            <div>|</div>
            <div
              className={`control-box ${
                typeSearch == "expired" ? "selected" : ""
              }`}
              onClick={() => handleTypeSelection("expired")}
            >
              <div className="tire-status-card">
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {dashboardData?.find((data) => data._id === "expired")
                    ?.count ?? 0}
                </p>
                <p
                  style={{
                    marginBottom: "0px",
                    color: "rgba(76, 120, 137, 1)",
                    fontSize: "14px",
                    fontWeight: "300",
                  }}
                >
                  expired
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card" style={{ padding: "0px", marginTop: "20px" }}>
        <div className="col-md-12 col-lg-12 col-xs-12">
          <DataTablePagination1
            columns={columns}
            data={tyres}
            totalRows={totalDoc}
            page={page}
            perPage={perPage}
            onPageChange={handlePageChange}
            onPerPageChange={handlePerRowsChange}
          />
        </div>
      </div>
    </div>
  );
};

export default TyreManagement;
